module.exports = __webpack_public_path__ + "88aac57e0bca8b4b70b23f35943de7a8.pdf";